var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportStatusTable',{attrs:{"is-table-locked":_vm.isTableLocked,"loading":_vm.loading,"per-page":_vm.perPage,"table-data":_vm.historyData,"total-records":_vm.totalRecords},on:{"on-page":function($event){return _vm.onPage($event)},"on-sort":function($event){return _vm.onSort($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }